export default {
  privat: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Soluzioni',
    breadcrumbCurrent: 'Casa e proprietà',
    hero: {
      eyebrow: 'Clienti privati',
      title: 'La tua casa sotto controllo, ben pianificata e installata con discrezione',
      lead: 'Casa unifamiliare, appartamento o condominio: proteggiamo la tua privacy e la tua proprietà con sistemi di telecamere su misura. Senza allarmismi, senza sorveglianza eccessiva.',
    },
    useCases: {
      title: 'Soluzioni per la tua casa',
      lead: 'Ogni casa è diversa. Consideriamo i tuoi accessi, le condizioni di luce e i tuoi desideri, pianificando i giusti punti di sorveglianza.',
      items: {
        '0': { title: 'Porta e ingresso', desc: 'La porta d’ingresso è il punto più importante. Pianifichiamo una telecamera discreta con buona risoluzione, per riconoscimento facciale e pacchi.' },
        '1': { title: 'Vialetto e garage', desc: 'Riconoscimento targhe, sorveglianza veicoli e controllo accessi con telecamere esterne resistenti e visione notturna.' },
        '2': { title: 'Giardino e terrazza', desc: 'Sorveglia gli accessi al giardino, le terrazze e gli ingressi secondari. Telecamere resistenti con grandangolo per la visione d’insieme.' },
        '3': { title: 'Ingressi secondari e cantina', desc: 'Spesso trascurati, ma un punto di accesso diffuso. Telecamere aggiuntive chiudono l’ultima falla.' },
        '4': { title: 'Condomini', desc: 'Ingresso, scale e aree esterne: pianificati nel rispetto della privacy, con mascheramento e segnaletica.' },
        '5': { title: 'Accesso da smartphone', desc: 'Vista live e riproduzione sul tuo telefono, a casa o in viaggio. Configuriamo tutto.' },
      },
    },
    night: {
      eyebrow: 'Visione notturna',
      title: 'Sicurezza che non dorme',
      lead: 'La maggior parte degli episodi avviene al buio. Con telecamere speciali giorno/notte mantieni il controllo anche di notte, in bianco e nero a infrarossi o a colori.',
      items: {
        '0': { title: 'Visione notturna a infrarossi', desc: 'Immagini nitide anche nel buio totale, fino a 30 m di portata a seconda del modello.' },
        '1': { title: 'Colore notturno', desc: 'Immagini a colori di notte invece del bianco e nero, grazie a sensori Starlight molto sensibili.' },
        '2': { title: 'Illuminazione intelligente', desc: 'LED a luce bianca al movimento come deterrente e per riprese a colori.' },
      },
    },
    privacy: {
      eyebrow: 'Protezione dei dati',
      title: 'Proteggere le zone private, rispettare i diritti',
      lead: 'Nella videosorveglianza privata la protezione dei dati è particolarmente importante. Fin dall’inizio curiamo:',
      list: {
        '0': 'Nessuna ripresa di strade pubbliche o proprietà vicine',
        '1': 'Mascheramento delle zone private nella telecamera o nel registratore',
        '2': 'Segnaletica agli ingressi (raccomandata per legge)',
        '3': 'Archiviazione locale: i tuoi dati restano da te',
        '4': 'Diritti di accesso e gestione utenti per i condomini',
      },
      note: 'Nota: la liceità legale della videosorveglianza dipende dal singolo caso. Ti consigliamo, ma non sostituiamo la consulenza legale.',
    },
    cta: {
      title: 'Proteggi ciò che conta per te',
      lead: 'Un primo colloquio senza impegno ti mostra le possibilità per la tua casa, con trasparenza e senza pressioni.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Avvia il pianificatore di telecamere',
    },
  },
};